import { Database } from "@vuex-orm/core";

// vuex orm
import User from "./models/User.js";

import Building from "./models/Building.js";
import BuildingLot from "./models/BuildingLot.js";
import BuildingOwner from "./models/BuildingOwner.js";
import MeetingGuest from "./models/MeetingGuest.js";
import Contact from "./models/Contact.js";
import Majority from "./models/Majority.js";
import Mandate from "./models/Mandate.js";
import Media from "./models/Media.js";
import Meeting from "./models/Meeting.js";
import Resolution from "./models/Resolution.js";
import ResolutionCatalog from "./models/ResolutionCatalog.js";
import Tag from "./models/Tag.js";
import VotingCategory from "./models/VotingCategory.js";
import BuildingOwnerVotingRight from "./models/BuildingOwnerVotingRight";

import ResolutionCatalogTag from "./models/ResolutionCatalogTag";
import MeetingResolution from "./models/MeetingResolution";
import ResolutionVote from "./models/ResolutionVote";
import BuildingOwnerBuildingLot from "./models/BuildingOwnerBuildingLot";
import BuildingMajorities from "./models/BuildingMajorities.js";
import MeetingCorrespondenceVote from "./models/MeetingCorrespondenceVote.js";
import Configuration from "./models/Configuration.js";
import Docage from "./models/Docage.js";

// vuex
import resolutionVotes from "../vuex/modules/resolution-votes";
import mandates from "../vuex/modules/mandates";
import meetings from "../vuex/modules/meetings";

const database = new Database();

database.register(User);

database.register(Building);
database.register(BuildingLot);
database.register(BuildingOwner);
database.register(MeetingGuest);
database.register(Contact);
database.register(Majority);
database.register(Mandate, mandates);
database.register(Media);
database.register(Meeting, meetings);
database.register(Resolution);
database.register(ResolutionCatalog);
database.register(Tag);
database.register(VotingCategory);
database.register(BuildingOwnerVotingRight);
database.register(BuildingMajorities);
database.register(MeetingCorrespondenceVote);
database.register(Configuration);
database.register(Docage);

// EX: many-to-many pivot table
database.register(ResolutionCatalogTag);
database.register(MeetingResolution);
database.register(ResolutionVote, resolutionVotes);
database.register(BuildingOwnerBuildingLot);

export default database;
